import { StateProvider } from '@uirouter/angularjs';
import { HeaderService, HEADER_SERVICE } from './../core/header.service';
import { MonitorService, MONITOR_SERVICE } from './../monitor/monitor.service';
import { ManageController } from './manage.controller';
import { ManageService, MANAGE_SERVICE } from './manage.service';
import { registerComponentFromTransition } from "../core/lazy-route.helper";
import { APP_SHELL_STATE } from "../app-shell.route";

function getStatus(manageService: ManageService) {
    return manageService.servicesToWatch();
}
getStatus.$inject = [MANAGE_SERVICE];

export function configRoute($stateProvider: StateProvider) {
    $stateProvider.state("manage", {
        parent: APP_SHELL_STATE,
        url: "/manage",
        onExit: [MONITOR_SERVICE, (monitorService: MonitorService) => {
            return monitorService.start.then(() => {
                monitorService.hub.server.stopStatusTimer();
            });
        }],
        views: {
            content: {
                component: "manageComponent",
            }
        },
        lazyLoad: async (transition, state) => {
            const moduleExport: any = await import("./manage.component");
            registerComponentFromTransition(transition, "manageComponent", moduleExport.manageComponentOptions);
            return moduleExport;

        },
        resolve: {
            "services": getStatus,
            setTitle: [HEADER_SERVICE, (headerService: HeaderService) => {
                headerService.headerTitle = "Manage Services";
            }],
            startTimer: ["monitorService", (monitorService: MonitorService) => {
                return monitorService.start.then(() => {
                    monitorService.hub.server.startStatusTimer();
                });
            }]
        }
    });
}
configRoute.$inject = ["$stateProvider"];


// WEBPACK FOOTER //
// ./app/manage/manage.router.ts